<script lang="ts">
import { defineAsyncComponent } from 'vue';

export default defineAsyncComponent(() => import('./product-snippet.vue'));
</script>
